import { render } from "./BillsReceivable.vue?vue&type=template&id=4bcda0ea&scoped=true"
import script from "./BillsReceivable.vue?vue&type=script&lang=js"
export * from "./BillsReceivable.vue?vue&type=script&lang=js"

import "./BillsReceivable.vue?vue&type=style&index=0&id=4bcda0ea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcda0ea"]])

export default __exports__